import { render, staticRenderFns } from "./LimitEdit.vue?vue&type=template&id=ba3881cc&"
import script from "./LimitEdit.vue?vue&type=script&lang=ts&"
export * from "./LimitEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports